import { createFileRoute } from '@tanstack/react-router';
import { EmptyState } from '@/components/page-header';
import { PackEditor } from '@/features/accountant/pack-editor';
import { usePack } from '@/lib/accountant';

export const Route = createFileRoute('/reports/management/$packId')({ component: EditPack });

/** Screen A10 (document 06): edit a management report. */
function EditPack() {
  const { packId } = Route.useParams();
  const pack = usePack(packId);
  if (pack.isPending) return <p className="text-sm text-muted-foreground">Loading…</p>;
  if (pack.isError)
    return <EmptyState title="Could not load the management report" hint={pack.error.message} />;
  return <PackEditor key={pack.data.id} pack={pack.data} />;
}
